const teamImages = [
    "/images/About/Team/1.jpg",
    "/images/About/Team/2.jpg",
    "/images/About/Team/3.jpg",
    "/images/About/Team/4.jpg",
];

export default function TeamSlider() {
    return (
        <div className="w-full overflow-hidden">
            <div className="flex w-max animate-scroll gap-16">
                {[...teamImages, ...teamImages].map((img, index) => (
                    <div
                        key={index}
                        className="min-w-[180px] flex justify-center items-center"
                    >
                        <div className="w-36 h-36 rounded-full border-[5px] border-teal-500 bg-white overflow-hidden shadow-lg">
                            <img
                                src={img}
                                alt="Team"
                                className="w-full h-full object-cover"
                            />
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
}
